import React from "react";

import { navigate } from "gatsby";
import CloseIcon from "../../images/svg/CloseIcon";
import { UnoButton } from "@blunopay/bluno-react-library";

const DemoCompleteClone = ({ setOpenModal, flowType = "home" }) => {
  const handleCloseClick = () => {
    if (flowType === "home") {
      setOpenModal(false);
    } else {
      window.parent.postMessage("close", "*");
    }
  };

  return (
    <div className="s-demo__complete">
      <div
        onClick={() => handleCloseClick()}
        className="s-demo__complete-close"
      >
        <CloseIcon color="#64748B" />
      </div>
      <img
        className="s-demo__complete-logo"
        src="https://static.bluno.in/landing/demo-success-logo.gif"
        alt="bluno"
      />
      <div className="s-demo__complete-text-container">
        <h1 className="s-demo__complete-title">
          Thank you! We’ve received your request
        </h1>
        <p className="s-demo__complete-text">
          Our team will get back to you shortly
        </p>
      </div>
      <UnoButton
        buttonLabel="Okay, got it!"
        type="primary"
        onClick={() => handleCloseClick()}
        width="124px"
        height="40px"
        extraClass="s-demo__complete-button"
      />
    </div>
  );
};

export default DemoCompleteClone;
